module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-verify"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('div', {
    staticClass: "box section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_c('div', {
    staticClass: "login-form form-horizontal"
  }, [(_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n                " + _vm._s(_vm.error) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('form-input', {
    attrs: {
      "type": "token",
      "name": "token",
      "fa": "key",
      "mdi": "vpn_key",
      "placeholder": "Verification Token",
      "value": _vm.token,
      "error": _vm.errors.token,
      "required": "true",
      "autofocus": "true",
      "disabled": _vm.isLoading
    },
    on: {
      "onInput": _vm.onInput
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('p', {
    staticClass: "control submit"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined is-fullwidth",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.submit(_vm.token)
      }
    }
  }, [_vm._v("\n                  Verify\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "control notification is-primary"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.success = undefined
      }
    }
  }), _vm._v("\n                " + _vm._s(_vm.success) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined is-fullwidth",
    attrs: {
      "disabled": !_vm.success
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/login')
      }
    }
  }, [_vm._v("\n                  Proceed To Login\n                ")])]) : _vm._e()], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header has-text-centered"
  }, [_c('h1', [_vm._v("Email Verification")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2989a2c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages_auth/Verify.vue
// module id = 809
// module chunks = 1